import { differenceInCalendarDays, format, parseISO } from 'date-fns';
import pluralize from 'pluralize';
import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { type CreditUsageStats } from '~/components/CreditUsageMeter/types';

export type CreditUsageMeterResetDateProps = Pick<ComponentProps<'div'>, 'className'> &
  Pick<CreditUsageStats, 'nextCycleStartAt'>;

export const CreditUsageMeterResetDate = memo(({ nextCycleStartAt, className }: CreditUsageMeterResetDateProps) => {
  // Parse only the date portion (YYYY-MM-DD) to avoid UTC timezone shifting the calendar day
  const resetDate = parseISO(nextCycleStartAt.substring(0, 10));
  const daysUntilReset = Math.max(0, differenceInCalendarDays(resetDate, new Date()));
  const dateOfReset = format(resetDate, 'MMM d');

  return (
    <div className={cn('flex w-full items-center justify-between gap-1 font-medium text-12', className)}>
      <span className="text-gray-9">Limit resets in</span>
      <span className="text-gray-11">
        {pluralize('day', daysUntilReset, true)} · {dateOfReset}
      </span>
    </div>
  );
});

CreditUsageMeterResetDate.displayName = 'CreditUsageMeterResetDate';
